import { render, staticRenderFns } from "./notification-recipient-chip.vue?vue&type=template&id=2fa77ada"
import script from "./notification-recipient-chip.vue?vue&type=script&lang=js"
export * from "./notification-recipient-chip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports